import { useState, useContext } from 'react';
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { AppContext, ERROR_SEVERITY } from 'commons-ui';
import { SelectedAthenaCrudType } from 'pages/dashboard/athenaDashboard/listAthenaRequest/types';
import useService from '../../../useService';

const useAthenaUpdateDetails = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const { updateAthenaCrudRequest } = useService();
	const { path } = useRouteMatch();
	const location = useLocation();
	const rowData = _get(location, ['state', 'rowData']);

	const handleFormSubmit = async (selectedCrud: SelectedAthenaCrudType) => {
		setShowLoader(true);
		try {
			const response = await updateAthenaCrudRequest(rowData._id, selectedCrud, showAlert);
			if (response) {
				history.push({
					pathname: `${path}/listAthenaCrudRequests`
				});
			}
		} catch (error: any) {
			showAlert(error.error || 'Something went wrong', { type: ERROR_SEVERITY.ERROR });
		} finally {
			setShowLoader(false);
		}
	};

	const handleFormCancel = () => {
		history.goBack();
	};
	const data = rowData
		? {
				...rowData,
				defaultQueryParams:
					typeof rowData.defaultQueryParams === 'string'
						? rowData.defaultQueryParams
						: JSON.stringify(rowData.defaultQueryParams, null, 2)
		  }
		: {};
	return { showLoader, setShowLoader, handleFormCancel, handleFormSubmit, data };
};

export default useAthenaUpdateDetails;
